import MovieSearch from "./MovieSearch";
export default MovieSearch;